<template>
  <div class="form-group" :class="{ 'required': required }">
    <label v-if="label">{{ label }}<sup v-if="required">*</sup></label>
    <input  v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)"
    :name="name"
    :type="type"
    class="form-control"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    v-on:blur="$emit('blur')"
    />
    <p v-show="vErrors.has(errorName)" class="control has-icon has-icon-right"><i class="fa fa-warning" style="color: #E74C3C;"></i> <span class="help has-error"> {{ vErrors.first(errorName) }}</span></p>
  </div>
</template>
<script>
export default {
  name: 'text-input',
  props: [
    'value',
    'name',
    'label',
    'type',
    'placeholder',
    'vErrors',
    'scope',
    'autocomplete',
    'required'
  ],
  computed: {
    errorName() {
      if(this.scope) {
        return this.scope + '.' + this.name;
      }

      return this.name;
    }
  }
};
</script>